
import { Vue, Component, Prop } from "vue-property-decorator";
import ChipWithLinkData from "@/types/ChipWithLinkData";
import ChipWithLink from "@/components/common/ChipWithLink.vue";

@Component({
  components: {
    ChipWithLink,
  },
})
export default class ChipsWithMore extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly chipWithLinkDatas!: ChipWithLinkData[];
  @Prop({ type: Number, default: 0 }) readonly limit!: number;
  @Prop({ type: Boolean, default: false }) readonly wrapChips!: boolean;

  get filteredChipWithLinkDatas() {
    return this.limit <= 0
      ? this.chipWithLinkDatas
      : this.chipWithLinkDatas.slice(0, this.limit);
  }

  get extra() {
    return this.chipWithLinkDatas.length && this.limit
      ? this.chipWithLinkDatas.length - this.limit
      : 0;
  }

  get variantClass() {
    switch (this.variant) {
      case "green":
        return "bg-greenChip text-lightGreen";
      case "blue":
        return "bg-lightBlue text-darkBlue";
      case "gray":
        return "bg-grayChip text-storm-gray";
      default:
        return "bg-grayChip text-storm-gray";
    }
  }

  get variant() {
    return this.chipWithLinkDatas.length
      ? this.chipWithLinkDatas[0].variant
      : "default";
  }
}
